import { readable } from "svelte/store";

export const animationTime = readable(700);
